var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h2',{staticClass:"px-3"},[_vm._v(_vm._s(_vm.$store.getters.error))])
}
var staticRenderFns = []

export { render, staticRenderFns }